<template>

<div
      class="w-full flex flex-row-reverse p-3 pr-6 my-6 rounded-b-lg "
    >
      
      <div class="flex items-center space-x-5">
        <div> 
          <router-link to="/news" class="focus:outline-none group">
              <span
                class="bar-list-item-icon opacity-75 text-red-600 group-hover:text-red-300"
              >
                <i class="fas fa-star text-lg " title="What's new"></i>
              </span>
              <span class="ml-2 "
                >What's new</span
              >
            </router-link>
        </div>
      <div v-if="showForSchool" class="border-r border-gray-500 pr-5">
        <TheNoticeBoard clas="text-left"></TheNoticeBoard>
      </div>
      


      <div class="hover:opacity-75"> 
          <router-link
              to="/account">
              <div class="flex space-x-3 items-center">
                <div class="font-bold">{{ userName }}</div>
                    <div
                    class="rounded-full bg-white text-slate-700 font-bold h-10 w-10 text-xxs text-center pt-3"
                     >
                    {{ userInitials }}
                    </div>
                  
                  </div>
            </router-link>

      </div>
      
      </div>
    </div>

</template>

<script>
import { mapGetters } from "vuex";

const TheNoticeBoard = () => import("@/components/TheNoticeBoard.vue");

export default {
  name: "topbar",
  props: {
  },
  computed: {
    ...mapGetters({ 
      currentUser: "currentUser",
    }),
    showForSchool() {
      return this.currentUser.isSchool;
    },
    userName() {
      return this.currentUser.name;
    },
    userInitials() {
      const result = this.currentUser.name || "  "

      return result
        .split(" ")
        .map((n) => n[0])
        .join("")
        .substring(0, 3)
        .toUpperCase();
    }
  },
  methods: {
    setLogo() {
      return (
        // "/static/images/domains/" + this.currentUser.s choolLogo + "-small.png"
        "/static/images/passport-side-logo.png"
      );
    },
  },
  components: {
    TheNoticeBoard,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>
